var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoInfo = function SvgIcoInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "17px",
    viewBox: "0 0 7 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ico_info")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25.1_Login_Error",
    transform: "translate(-46.000000, -380.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feedback_info",
    transform: "translate(22.000000, 364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_info",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "-1.47437609e-13 6.84355428 5.25351531 5.59999967 5.25351531 15.999999 2.0535155 15.999999 2.0535155 7.24453082"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "0.453515598 15.999999 3.65351541 15.1999991 6.85351522 15.999999 6.85351522 16.799999 0.453515598 16.799999"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.65351541,
    cy: 1.5999999,
    r: 1.5999999
  })))))));
};
export default SvgIcoInfo;